const SKELETON_ITEMS = 3;

export default function TrendingSkeletonLoader() {
  return (
    <section
      className="trending-search trending-search--loading"
      aria-label="Cargando búsquedas en tendencia"
      aria-busy="true"
    >
      <ul className="trending-search__list" aria-hidden="true">
        {Array.from({ length: SKELETON_ITEMS }, (_, index) => (
          <li key={index} className="trending-search__skeleton">
            <span className="trending-search__skeleton-icon" />
            <span className="trending-search__skeleton-copy">
              <span className="trending-search__skeleton-category" />
              <span className="trending-search__skeleton-topic" />
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}